import {Card} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithNoMarks} from '../../utils'
import type {IconLinkItem} from '../../types'
import {SupportGrid} from './SupportGrid'

export function SupportIconCards({items}: {items: IconLinkItem[]}) {
  return items.map((item, index) => {
    const Octicon = getPrimerIcon(item.fields.icon)
    return (
      <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
        <Card href={item.fields.href}>
          {Octicon && <Card.Icon icon={<Octicon />} color="default" hasBackground />}
          <Card.Heading>{renderWithNoMarks(item.fields.heading)}</Card.Heading>
          <Card.Description>{renderWithNoMarks(item.fields.description)}</Card.Description>
        </Card>
      </SupportGrid.Item>
    )
  })
}
